import { useLanguage } from "../../../i18n/LanguageContext";
import "./voice.css";

const text = {
    en: {
        app: "Smart Key · Room 214",
        help: "How can we help?",
        ask: "Can I get two extra towels, please?",
        assistant: "✦ Smart Key AI",
        reply: "Of course! Two extra towels are on their way to Room 214.",
        delivered: "✓ Delivered · ",
        console: "Service requests",
        live: "Live",
        waiting: "Listening for new requests…",
        room214: "Room 214",
        statusNew: "New",
        statusProgress: "In progress",
        statusDone: "✓ Complete",
        towels: "Extra towels ×2 · Housekeeping",
        routed: "✦ Understood and routed by AI",
        room108: "Room 108",
        lateCheckout: "Late check-out · Front desk",
        room305: "Room 305",
        acCheck: "AC check · Maintenance",
    },
    ar: {
        app: "ضياف · الغرفة 214",
        help: "كيف نخدمك؟",
        ask: "ممكن منشفتين إضافيتين من فضلك؟",
        assistant: "✦ مساعد ضياف الذكي",
        reply: "بكل سرور! منشفتان إضافيتان في الطريق إلى الغرفة 214.",
        delivered: "✓ تم التوصيل · ",
        console: "طلبات الخدمة",
        live: "مباشر",
        waiting: "بانتظار طلبات جديدة…",
        room214: "الغرفة 214",
        statusNew: "جديد",
        statusProgress: "قيد التنفيذ",
        statusDone: "✓ مكتمل",
        towels: "مناشف إضافية ×2 · التدبير المنزلي",
        routed: "✦ فهمه ووجّهه الذكاء الاصطناعي",
        room108: "الغرفة 108",
        lateCheckout: "مغادرة متأخرة · الاستقبال",
        room305: "الغرفة 305",
        acCheck: "فحص التكييف · الصيانة",
    },
};

// Guest asks by voice -> AI replies and routes the request -> staff console tracks it to Complete. One 9s loop.
const VoiceScene = () => {
    const { lang, isRtl } = useLanguage();
    const t = text[lang];
    const dir = isRtl ? "rtl" : "ltr";
    return (
        <>
            <div className="skv-backdrop"></div>

            <div className="sk-mobile skv-phone">
                <div className="sk-mobile-screen" dir={dir}>
                    <div className="sk-mobile-label">{t.app}</div>
                    <div className="sk-mobile-heading">{t.help}</div>

                    <div className="skv-user">{t.ask}</div>
                    <div className="skv-typing"><i></i><i></i><i></i></div>
                    <div className="skv-reply">
                        <b>{t.assistant}</b>
                        {t.reply}
                    </div>
                    <div className="skv-done">{t.delivered}<span>★★★★★</span></div>

                    <div className="skv-bars">
                        <i></i><i></i><i></i><i></i><i></i><i></i><i></i>
                    </div>
                    <div className="skv-mic">
                        <span className="skv-mic-ring"></span>
                        <span className="skv-mic-ring r2"></span>
                        <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="9" y="2.5" width="6" height="11" rx="3" />
                            <path d="M5.5 10.5a6.5 6.5 0 0 0 13 0M12 17v4" />
                        </svg>
                    </div>
                </div>
            </div>

            <div className="skv-orb">
                <svg viewBox="0 0 24 24" fill="#fff">
                    <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9z" />
                    <path d="M18.5 15l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z" />
                </svg>
            </div>
            <div className="skv-dot"></div>
            <div className="skv-dot d2"></div>
            <div className="skv-dot d3"></div>

            <div className="sk-panel skv-console" dir={dir}>
                <div className="sk-panel-title">{t.console} <b>{t.live}</b></div>
                <div className="skv-slot">
                    <div className="skv-waiting">{t.waiting}</div>
                    <div className="skv-row skv-new">
                        <div className="skv-row-top">
                            <strong>{t.room214}</strong>
                            <span className="skv-status">
                                <span className="sk-pill skv-st1">{t.statusNew}</span>
                                <span className="sk-pill skv-st2">{t.statusProgress}</span>
                                <span className="sk-pill skv-st3">{t.statusDone}</span>
                            </span>
                        </div>
                        <div>{t.towels}</div>
                        <div className="skv-ai-tag">{t.routed}</div>
                    </div>
                </div>
                <div className="skv-row">
                    <div className="skv-row-top">
                        <strong>{t.room108}</strong>
                        <span className="sk-pill skv-green">{t.statusDone}</span>
                    </div>
                    <div>{t.lateCheckout}</div>
                </div>
                <div className="skv-row">
                    <div className="skv-row-top">
                        <strong>{t.room305}</strong>
                        <span className="sk-pill skv-blue">{t.statusProgress}</span>
                    </div>
                    <div>{t.acCheck}</div>
                </div>
            </div>
        </>
    )
}
export default VoiceScene;
